"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEditorialCategoryOrPage = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
/**
 * Fetch function that fetches data for editorial category or landing page from GraphQL.
 */
const getEditorialCategoryOrPage = async ({
  graphQlUrl,
  headers,
  pageId,
  previewMode,
  landingPageId
}) => {
  const data = await (0, _fetching.fetchGraphql)({
    query: _queriesNet.editorialCategoryOrPageQuery,
    url: graphQlUrl,
    variables: {
      pageId,
      landingPageId
    },
    headers: {
      ...headers,
      [_fetching.PREVIEW_MODE]: previewMode ?? false
    },
    ...(previewMode ? {
      timeout: 30000
    } : null)
  });
  const {
    editorialLandingPage,
    editorialPage,
    rootEditorialLandingPage
  } = data.application ?? {};
  return {
    application: {
      editorialLandingPage: {
        ...editorialLandingPage,
        landingPageId: editorialLandingPage?.landingPageId ?? '',
        themeItems: (0, _utils.filterOutCurrentCategory)({
          pageId,
          categories: rootEditorialLandingPage?.themeItems
        })
      },
      editorialPage
    }
  };
};
exports.getEditorialCategoryOrPage = getEditorialCategoryOrPage;
